export default "__VITE_ASSET__DlV9kb3b__"